export enum LsosContactActionTypes {
  AddContact = '[LsosRenewals/Page] Add Contact',
  AddContactSuccess = '[LsosRenewals/Page] Add Contact Success',
  AddContactFailure = '[LsosRenewals/Page] Add Contact Failure',
}

export enum LsosRenewalsOverviewActionTypes {
  Init = '[RenewalsOverview Page] Init',

  // #TODO - these need to be removed
  LoadQuotes = '[RenewalsOverview/Page] Load Quotes',
  LoadQuotesSuccess = '[RenewalsOverview/Page] Load Quotes Success',
  LoadEmptyQuotesSuccess = '[RenewalsOverview/API] Load Empty Quotes Success',
  LoadQuotesFailure = '[RenewalsOverview/API] Load Quotes Failure',

  LoadProposal = '[RenewalsOverview/Page] Load Proposal',

  PaymentMarkedComplete = '[RenewalsOverview Page] Payment Marked Complete',

  Destroyed = '[RenewalsOverview Page] Destroyed',
}

export enum LsosRenewalsApplicationActionTypes {
  // Application Home
  Init = '[RenewalsApplication/Page] Init',

  ReadConfig = '[RenewalsApplication/Page] Read Configs',
  ReadConfigSuccess = '[RenewalsApplication/API] Read Configs Success',
  ReadConfigFailure = '[RenewalsApplication/API] Read Configs Failure',

  BuildApplication = '[RenewalsApplication/Page] Build Application',

  AddProposal = '[RenewalsApplication/Page] Add Proposal',
  AddProposalSuccess = '[RenewalsApplication/API] Add Proposal Success',
  AddProposalFailure = '[RenewalsApplication/API] Add Proposal Failure',

  LoadQuotes = '[RenewalsApplication/Page] Load Quotes',
  LoadQuotesSuccess = '[RenewalsApplication/API] Load Quotes Success',
  LoadEmptyQuotes = '[RenewalsApplication/API] Load Empty Quotes Success',
  LoadQuotesFailure = '[RenewalsApplication/API] Load Quotes Failure',

  LoadProposal = '[RenewalsApplication/Page] Load Proposal',
  LoadProposalSuccess = '[RenewalsApplication/API] Load Proposal Success',
  LoadProposalFailure = '[RenewalsApplication/API] Load Proposal Failure',

  ContinueProposal = '[RenewalsApplication/Page] Continue Proposal',
  ContinueProposalWithoutRebuild = '[RenewalsApplication/Page] Continue Proposal Without Rebuild',

  ContinueProposalWithInitialBuild = '[RenewalsApplication/Page] Continue Proposal With Initial Build',

  SaveInitialBuild = '[RenewalsApplication/Page] Save Initial Build',
  SaveInitialBuildSuccess = '[RenewalsApplication/API] Save Initial Build Success',
  SaveInitialBuildFailure = '[RenewalsApplication/API] Save Initial Build Failure',

  LoadClientContacts = '[RenewalsApplication/Page] Load Client Contacts',

  LoadClientAsBroker = '[RenewalsApplication/Page] Load Client As Broker',
  LoadClientAsBrokerSuccess = '[RenewalsApplication/Page] Load Client As Broker Success',
  LoadClientAsBrokerFailure = '[RenewalsApplication/Page] Load Client As Broker Failure',

  BuildForSaveProposal = '[RenewalsApplication/Page] Build Proposal For Save',
  SaveProposal = '[RenewalsApplication/Page] Save Proposal',
  SaveProposalSuccess = '[RenewalsApplication/API] Save Proposal Success',
  SaveProposalFailure = '[RenewalsApplication/API] Save Proposal Failure',

  BuildForSaveAndContinueProposal = '[RenewalsApplication/Page] Build Proposal For Save And Continue',
  SaveAndContinueProposal = '[RenewalsApplication/Page] Save And Continue Proposal',
  SaveAndContinueProposalSuccess = '[RenewalsApplication/API] Save And Continue Proposal Success',
  SaveAndContinueProposalFailure = '[RenewalsApplication/API] Save And Continue Proposal Failure',

  BuildForSubmitProposal = '[RenewalsApplication/Page] Build Proposal For Submit',
  SubmitProposal = '[RenewalsApplication/Page] Submit Proposal',
  SubmitProposalSuccess = '[RenewalsApplication/API] Submit Proposal Success',
  SubmitProposalFailure = '[RenewalsApplication/API] Submit Proposal Failure',

  UpdateStepsState = '[RenewalsApplication/Page] Update Steps State',

  SubmitFeedback = '[RenewalsApplication/Page] Submit Feedback',
  SubmitFeedbackSuccess = '[RenewalsApplication/API] Submit Feedback Success',
  SubmitFeedbackFailure = '[RenewalsApplication/API] Submit Feedback Failure',

  Reset = '[RenewalsApplication/Page] Reset',

  SetNewQuoteId = '[RenewalsApplication/Page] Set Quote Id From New Application',

  StepChange = '[RenewalsApplication/Page] Step Change',
}
